module.exports = __webpack_public_path__ + "img/loader.5699b3da.gif";